// Função para inicializar cada seção Viva Momento
function initVivaMomento(sectionId) {
    const lamppostSection = document.getElementById(`lamppostSection-${sectionId}`);
    if (!lamppostSection) return;

    const bulb = lamppostSection.querySelector('.bulb');
    const lightGlow = lamppostSection.querySelector('.light-glow');
    const lightCone = lamppostSection.querySelector('.light-cone');
    const lamppostImage = lamppostSection.querySelector('.lamppost-image');
    const lampTop = lamppostSection.querySelector('.lamp-top');
    const starsContainer = lamppostSection.querySelector(`#stars-${sectionId}`);

    if (!bulb || !lightGlow || !lightCone || !lamppostImage || !lampTop) return;

    // Criar estrelas
    for (let i = 0; i < 100; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        star.style.left = Math.random() * 100 + '%';
        star.style.top = Math.random() * 100 + '%';
        star.style.animationDelay = Math.random() * 3 + 's';
        starsContainer.appendChild(star);
    }

    // Atualizar largura do cone dinamicamente
    const style = document.createElement('style');
    document.head.appendChild(style);

    // Calcular posição da lâmpada na imagem
    function calculateBulbPosition() {
        const imgRect = lamppostImage.getBoundingClientRect();
        const imgHeight = imgRect.height;
        const imgWidth = imgRect.width;
        
        // Ajustar tamanho do lamp-top para corresponder à imagem
        lampTop.style.width = `${imgWidth}px`;
        lampTop.style.height = `${imgHeight}px`;
        
        // Posição relativa da lâmpada (ajuste esses valores conforme sua imagem)
        // 20% do topo da imagem e 50% horizontal (centro)
        const bulbTopPercent = 0.20;
        const bulbLeftPercent = 0.50;
        
        const bulbTop = imgHeight * bulbTopPercent;
        const bulbLeft = imgWidth * bulbLeftPercent;
        
        // Ajustar posição dos elementos de luz
        bulb.style.top = `${bulbTop}px`;
        bulb.style.left = `${bulbLeft}px`;
        
        lightGlow.style.top = `${bulbTop}px`;
        lightGlow.style.left = `${bulbLeft}px`;
        
        lightCone.style.top = `${bulbTop}px`;
        lightCone.style.left = `${bulbLeft}px`;
    }

    function updateLamppost() {
        const sectionRect = lamppostSection.getBoundingClientRect();
        const sectionTop = sectionRect.top;
        const sectionHeight = sectionRect.height;
        const viewportHeight = window.innerHeight;

        // Calcular a posição relativa dentro da seção
        const scrollProgress = Math.max(0, Math.min(1, (viewportHeight - sectionTop) / (sectionHeight + viewportHeight)));

        // Intensidade aumenta conforme você rola pela seção
        const intensity = Math.min(scrollProgress * 1.5, 1);

        if (intensity > 0.05) {
            bulb.classList.add('on');
            lamppostSection.classList.add('lit');
            
            // Brilho da lâmpada
            const glowSize = 250 + (intensity * 500);
            lightGlow.style.width = `${glowSize}px`;
            lightGlow.style.height = `${glowSize}px`;
            lightGlow.style.opacity = intensity * 0.9;
            
            // Cone de luz
            const coneWidth = 150 + (intensity * 400);
            lightCone.style.opacity = intensity * 0.7;
            lightCone.style.width = `${coneWidth}px`;
            
            // Sombra da lâmpada
            bulb.style.boxShadow = `
                0 0 ${30 + intensity * 50}px rgba(255, 215, 0, ${intensity}),
                0 0 ${60 + intensity * 100}px rgba(255, 215, 0, ${intensity * 0.7}),
                0 0 ${90 + intensity * 150}px rgba(255, 215, 0, ${intensity * 0.4})
            `;

            // Atualizar largura do cone
            style.textContent = `
                #lamppostSection-${sectionId} .light-cone::before {
                    width: ${coneWidth}px !important;
                }
            `;
            
        } else {
            bulb.classList.remove('on');
            lamppostSection.classList.remove('lit');
            lightGlow.style.width = '0px';
            lightGlow.style.height = '0px';
            lightGlow.style.opacity = '0';
            lightCone.style.opacity = '0';
            bulb.style.boxShadow = '0 0 0 rgba(255, 215, 0, 0)';
        }
    }

    // Event listeners
    window.addEventListener('scroll', updateLamppost);
    window.addEventListener('resize', () => {
        calculateBulbPosition();
        updateLamppost();
    });

    // Aguardar carregamento da imagem
    if (lamppostImage.complete) {
        calculateBulbPosition();
        updateLamppost();
    } else {
        lamppostImage.addEventListener('load', () => {
            calculateBulbPosition();
            updateLamppost();
        });
    }

    // Inicializar
    setTimeout(() => {
        calculateBulbPosition();
        updateLamppost();
    }, 100);
}

// Para múltiplas instâncias da seção
document.addEventListener('DOMContentLoaded', function() {
    // Se não houver inicialização específica por seção, inicializa todas
    const sections = document.querySelectorAll('.lamppost-section');
    sections.forEach(section => {
        const sectionId = section.id.replace('lamppostSection-', '');
        if (sectionId) {
            initVivaMomento(sectionId);
        }
    });
});